import { format, startOfMonth, subMonths } from 'date-fns';

const MESES_DISPONIVEIS = 3;

export function getDataInicioRelatorios(): Date {
  // Pega a data atual
  const hoje = new Date();
  // Subtrai 3 meses
  const tresMesesAtras = subMonths(hoje, MESES_DISPONIVEIS);
  // Retorna o primeiro dia daquele mês
  return startOfMonth(tresMesesAtras);
}

export function getDataFimRelatorios(): Date {
  return new Date();
}

export function formatarDataRelatorio(date: Date): string {
  return format(date, 'dd/MM/yyyy');
}

export function getMensagemDisponibilidadeRelatorios(): string {
  const dataInicio = formatarDataRelatorio(getDataInicioRelatorios());
  const dataAtual = formatarDataRelatorio(getDataFimRelatorios());
  return `Só temos disponíveis dados para os relatórios de ${dataInicio} até ${dataAtual}. Para outras datas, entre em contato.`;
}
